
import { defineComponent } from "vue"
import type { Story } from "./WyfStories.vue"

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    story: {
      type: Object as VuePropType<Story | undefined>,
      default: undefined,
    },
  },

  computed: {
    isOpen: {
      get (): boolean {
        return this.value
      },
      set (value: boolean) {
        this.$emit("input", value)
      },
    },
  },
})
